import { fluid } from "./utils";
import { colors } from "~/styleguide";

export const fonts = {
    ambit: {
        fontFamily: "Ambit, sans-serif",
        fontWeight: 400
    },
    ambitSemiBold: {
        fontFamily: "Ambit, sans-serif",
        fontWeight: 600
    },
    ambitSemiBoldItalic: {
        fontFamily: "Ambit, sans-serif",
        fontWeight: 600,
        fontStyle: "italic"
    },
    ambitBold: {
        fontFamily: "Ambit, sans-serif",
        fontWeight: 700
    }
};

export const textStyles = {
    heading1XL: {
        ...fonts.ambitSemiBold,
        lineHeight: "1.1",
        extend: [
            fluid("font-size", { max: 120, min: 60 }),
            fluid("letter-spacing", { max: 1.5, min: 0 })
        ]
    },
    heading1: {
        ...fonts.ambitSemiBold,
        lineHeight: "1.1",
        extend: [
            fluid("font-size", { max: 72, min: 38 }),
            fluid("letter-spacing", { max: 1.5, min: 0 })
        ]
    },
    heading1Medium: {
        ...fonts.ambitSemiBold,
        lineHeight: "1.1",
        extend: [
            fluid("font-size", { max: 62, min: 34 }),
            fluid("letter-spacing", { max: 1.5, min: 0 })
        ]
    },
    heading1Small: {
        ...fonts.ambitSemiBold,
        lineHeight: "1.1",
        extend: [
            fluid("font-size", { max: 52, min: 30 }),
            fluid("letter-spacing", { max: 1.5, min: 0 })
        ]
    },
    heading1XS: {
        ...fonts.ambitSemiBold,
        lineHeight: "1.1",
        extend: [
            fluid("font-size", { max: 42, min: 28 }),
            fluid("letter-spacing", { max: 1.5, min: 0 })
        ]
    },
    heading2: {
        ...fonts.ambitSemiBold,
        lineHeight: "1.1",
        extend: [fluid("font-size", { max: 54, min: 30 })]
    },
    heading3: {
        ...fonts.ambitSemiBold,
        lineHeight: "117%",
        extend: [
            fluid("font-size", { max: 30, min: 24 }),
            fluid("letter-spacing", { max: 1, min: 0.25 })
        ]
    },
    heading4: {
        ...fonts.ambitSemiBold,
        lineHeight: "117%",
        letterSpacing: 1,
        extend: [fluid("font-size", { max: 24, min: 20 })]
    },
    resourceHeading: {
        ...fonts.ambitBold,
        color: colors.black,
        lineHeight: "125%",
        letterSpacing: "-0.1px",
        display: "block",
        extend: [
            fluid("font-size", { max: 24, min: 18 }),
            fluid("margin-top", { max: 15, min: 8 })
        ]
    },
    sidebarHeading: {
        ...fonts.ambit,
        fontWeight: "bold",
        extend: [fluid("font-size", { max: 18, min: 16 })],
        lineHeight: "125%",
        letterSpacing: "-0.1px",
        marginBottom: 20
    },
    marqueeEyebrow: {
        ...fonts.ambit,
        fontWeight: "bold",
        extend: [fluid("font-size", { max: 24, min: 16 })],
        lineHeight: "125%",
        letterSpacing: "0.5px",
        marginBottom: 20
    },
    paragraphXL: {
        ...fonts.ambit,
        lineHeight: "125%",
        letterSpacing: 0.5,
        extend: [fluid("font-size", { max: 30, min: 24 })]
    },
    paragraphLarge: {
        ...fonts.ambit,
        lineHeight: "125%",
        letterSpacing: 0.5,
        extend: [fluid("font-size", { max: 24, min: 18 })]
    },
    paragraphNormal: {
        ...fonts.ambit,
        lineHeight: "125%",
        letterSpacing: .5,
        extend: [fluid("font-size", { max: 20, min: 16 }),]
    },
    paragraphSmall: {
        ...fonts.ambit,
        lineHeight: "1.4",

        extend: [
            fluid("font-size", { max: 16, min: 16 }),
            fluid("letter-spacing", { max: 0.5, min: 0.3 })
        ]
    },
    tag: {
        fontSize: 12,
        lineHeight: "18px",
        letterSpacing: 0.1,
        display: "inline-block",
        "> a": {
            display: "inline-block",
            color: colors.black
        }
    },
    blockquote: {
        ...fonts.ambit,
        lineHeight: "120%",
        extend: [fluid("font-size", { max: 30, min: 22 })]
    },
    blockquoteSmall: {
        ...fonts.ambit,
        lineHeight: "125%",
        extend: [fluid("font-size", { max: 24, min: 16 })]
    },
    faqOrFeature: {
        ...fonts.ambit,
        fontWeight: "bold",
        extend: [fluid("font-size", { max: 18, min: 16 })]
    }
};

export const themeText = theme => {
    if (!theme || !theme.text || theme.text !== "dark")
        return {
            color: colors.white,
            borderColor: colors.white
        };

    if (theme.text === "dark")
        return {
            color: colors.black,
            borderColor: colors.black
        };
};

export const themeHeadline = theme => {
    if (!theme || !theme.text || theme.text !== "dark")
        return {
            color: colors.white
        };

    if (theme.text === "dark")
        return {
            color: "#182362"
        };
};
